import { render, staticRenderFns } from "./status-sub-tatus-type.vue?vue&type=template&id=0af7c050&"
import script from "./status-sub-tatus-type.vue?vue&type=script&lang=js&"
export * from "./status-sub-tatus-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports